<div class="stepper">
  @for (step of steps; track step; let i = $index) {
    <div class="step" [class.active]="i <= currentStep" (click)="stepClicked(step, i)">
      <div class="step-circle"><span>{{i + 1}}</span></div>
      <div class="step-title">{{step.name}}</div>
      <div class="step-bar-left"></div>
      <div class="step-bar-right"></div>
    </div>
  }
</div>
